import { SET_USER } from "./constant";

export const setUser = (userData = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_USER, payload: userData });
  };
};
